var _path;

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }

import * as React from "react";

function SvgClass(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 18,
    viewBox: "0 0 22 18",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.938.063H2.063A1.627 1.627 0 00.437 1.688v14.625a1.625 1.625 0 001.626 1.625h1.36a.813.813 0 00.733-.464 4.878 4.878 0 018.813 0 .813.813 0 00.734.463h6.235a1.627 1.627 0 001.625-1.625V1.688A1.627 1.627 0 0019.938.063zm-11.375 13a3.25 3.25 0 110-6.5 3.25 3.25 0 010 6.5zm11.374 3.25h-5.745a6.489 6.489 0 00-1.337-1.625H17.5a.812.812 0 00.813-.813v-9.75a.812.812 0 00-.813-.813h-13a.812.812 0 00-.813.813v9.75a.812.812 0 00.613.787 6.49 6.49 0 00-1.367 1.65h-.87V1.688h17.875v14.626z"
  })));
}

export default SvgClass;